import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SafeImage from "../../../layout/reusable/SafeImage";
import { getCMSAssets, getPortfolios } from "../../../utils/cms.utils";

const ServicesSingleMain = ({ singleData, services }) => {
    const descriptions = Array.isArray(singleData.description)
        ? [...singleData.description].sort(
            (a, b) => (a.orderNo ?? 0) - (b.orderNo ?? 0)
        )
        : [];

    const middleIndex = Math.ceil(descriptions.length / 2);

    const [assets, setAssets] = useState(null);
    const [relatedPortfolios, setRelatedPortfolios] = useState([]);

    useEffect(() => {
        setAssets(getCMSAssets());

        const allPortfolios = getPortfolios();

        const filtered = Array.isArray(allPortfolios)
            ? allPortfolios
                .filter(
                    (p) =>
                        Array.isArray(p.tags) &&
                        p.tags.includes(singleData.id)
                )
                .sort((a, b) => (a.orderNo ?? 0) - (b.orderNo ?? 0))
                .slice(0, 3)
            : [];

        setRelatedPortfolios(filtered);
    }, [singleData.id]);

    return (
        <div className="services__details section-padding mt-5">
            <div className="container">
                <div className="row">

                    {/* ===== MAIN CONTENT ===== */}
                    <div className="col-lg-8 p-5">
                        <div className="services__details-area text-center mt-2 mb-5">

                            <h2 className="services__details-title">
                                {singleData.titleEn}
                            </h2>

                            {singleData.titleId && (
                                <h5 className="services__details-subtitle muted">
                                    {singleData.titleId}
                                </h5>
                            )}

                            {/* HERO IMAGE */}
                            {singleData.image?.[0] && (
                                <SafeImage
                                    src={singleData.image[0]}
                                    alt={singleData.titleEn}
                                    isCoverImage
                                    className="services__details-hero"
                                />
                            )}

                            {/* OVERVIEW */}
                            <div className="services__details-overview">
                                <h4>Service Overview</h4>
                                <span />
                            </div>

                            {/* DESCRIPTION */}
                            {descriptions.map((item, index) => (
                                <React.Fragment key={index}>
                                    <div className="services__details-paragraph">
                                        <div
                                            className="desc-en"
                                            dangerouslySetInnerHTML={{
                                                __html: item.descEn,
                                            }}
                                        />
                                        {item.descId && (
                                            <div
                                                className="desc-id muted"
                                                dangerouslySetInnerHTML={{
                                                    __html: item.descId,
                                                }}
                                            />
                                        )}
                                    </div>

                                    {/* IMAGE BREAK */}
                                    {index + 1 === middleIndex &&
                                        singleData.image?.[1] && (
                                            <div className="services__details-image-break">
                                                <SafeImage
                                                    src={singleData.image[1]}
                                                    alt="Service detail"
                                                />
                                            </div>
                                        )}
                                </React.Fragment>
                            ))}

                        </div>
                    </div>

                    {/* ===== SIDEBAR ===== */}
                    <div className="col-lg-4 columns_sticky p-3">
                        <div className="all__sidebar">

                            {/* OUR SERVICES */}
                            <div className="all__sidebar-item">
                                <h4 className="text-center">Other Services</h4>
                                <ul className="all__sidebar-item-category">
                                    {services.map(item => (
                                        <li key={item.id}>
                                            <Link to={`/services/${item.id}`}>
                                                {item.titleEn}
                                                <i className="flaticon-right-up" />
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* RELATED PORTFOLIO */}
                            {relatedPortfolios.length > 0 && (
                                <div className="all__sidebar-item">
                                    <h4 className="text-center">
                                        Related Projects with {singleData.titleEn}
                                    </h4>

                                    <ul className="all__sidebar-item-portfolio">
                                        {relatedPortfolios.map(p => (
                                            <li key={p.id}>
                                                <Link to={`/portfolio/${p.id}`}>
                                                    <div className="sidebar-portfolio-item">
                                                        {p.logo && (
                                                            <img
                                                                src={p.logo}
                                                                alt={p.title}
                                                                className="sidebar-portfolio-logo"
                                                            />
                                                        )}
                                                        <div className="sidebar-portfolio-content">
                                                            <h6>{p.title}</h6>
                                                            {p.caption && (
                                                                <p className="muted">
                                                                    {p.caption}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>

                                    <div className="text-center mt-2">
                                        <Link
                                            to="/portfolio"
                                            className="small-link"
                                        >
                                            View All Projects →
                                        </Link>
                                    </div>
                                </div>
                            )}

                            {/* CTA */}
                            <div
                                className="all__sidebar-item-help services__details-cta"
                                style={{
                                    backgroundImage: `url(${assets?.vertical_banner})`,
                                }}
                            >
                                <h3>Ready for Your Next Project?</h3>
                                <Link
                                    className="build_button mt-20"
                                    to="/contact-us"
                                >
                                    Get an Advice
                                    <i className="flaticon-right-up" />
                                </Link>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ServicesSingleMain;
